import { render, staticRenderFns } from "./TermSectionComponent.vue?vue&type=template&id=b833dc26"
import script from "./TermSectionComponent.vue?vue&type=script&lang=js"
export * from "./TermSectionComponent.vue?vue&type=script&lang=js"
import style0 from "./TermSectionComponent.vue?vue&type=style&index=0&id=b833dc26&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports